import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import staff1 from '../../../../images/staff/member_2.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PromiseReason = ({ show, onClose, data }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [promise_count, setpromise] = useState("");
    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        
        if (!promise_count) {
            newErrors.cnt = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            reason: promise_count,
            branch_id: branch_id,
            user_id: user_id,
            staff_id: data.staff_id,
        };
        axios.post(`${baseURL}/team_management/store_reason`, postData)
            .then(response => {
                onClose();
                toast.success("Promise Count Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Promise Count Creation Failed");
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Promise Break Reason</h3>
                    {/* <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button> */}
                </div>
                <div className="modal-body">
                    <div className='d-flex align-items-center justify-content-start gap-4 mb-4'>
                        <div className="d-flex align-items-center">
                            <div className="avatar-preview">
                                <img
                                    id="saveImageFile"
                                    src={data.image ? data.image : staff1}
                                    alt={data.image ? data.image : staff1}
                                    className='w-100px h-120px'
                                />
                            </div>
                        </div>
                        <div>
                            <label className='fw-bold fs-5 text-black'>{data.name}</label>
                            <div className='d-block'>
                                <label className='fw-bold fs-5 text-dark'>{data.email}</label>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className='col-lg-12'>
                            <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Reason" 
                                maxLength={10}
                                value={promise_count} 
                                onChange={(e) => {
                                    setpromise(e.target.value)
                                }} 
                            />
                            {errors.cnt && <div className="text-danger fs-8 mt-1">{errors.cnt}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-end justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit Reason<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div >
        </Modal >
    );
};

export default PromiseReason;
